import {defineAsyncComponent} from 'vue';

export const HitForm = defineAsyncComponent(() => import('./HitForm.vue'));

export * from './input';
